import request, { PATCH } from '../../utils/request';

export default requestRecordId => request(`/request-records/${requestRecordId}/comments`, { method: PATCH });
